module.exports = __webpack_public_path__ + "img/fire4.ee503a6e.jpg";